var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoordinateSystem = function SvgCoordinateSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coordinate-system_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "coordinate-system_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#D9D9D9",
    stroke: "#000",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2,
    mask: "url(#coordinate-system_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.022 12c0 3.905-.66 7.393-1.687 9.868-.515 1.24-1.103 2.178-1.705 2.79-.598.61-1.149.84-1.63.84-.483 0-1.033-.23-1.632-.84-.601-.612-1.189-1.55-1.704-2.79C7.636 19.393 6.977 15.905 6.977 12s.659-7.394 1.687-9.869C9.18.891 9.767-.046 10.368-.659c.599-.609 1.15-.84 1.631-.84s1.033.231 1.631.84c.602.613 1.19 1.55 1.705 2.79 1.028 2.475 1.687 5.964 1.687 9.869Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999-3.465c3.905 0 7.393.66 9.869 1.687 1.24.515 2.177 1.103 2.79 1.705.609.598.84 1.149.84 1.63 0 .483-.231 1.033-.84 1.632-.613.601-1.55 1.189-2.79 1.704-2.476 1.028-5.964 1.688-9.87 1.688-3.904 0-7.393-.66-9.868-1.688C.89 4.378-.047 3.79-.66 3.189c-.609-.599-.84-1.15-.84-1.631s.231-1.033.84-1.631c.613-.602 1.55-1.19 2.79-1.705C4.605-2.806 8.094-3.465 12-3.465ZM11.999 17.406c3.905 0 7.393.659 9.869 1.687 1.24.515 2.177 1.103 2.79 1.704.609.599.84 1.15.84 1.631s-.231 1.033-.84 1.631c-.613.602-1.55 1.19-2.79 1.705-2.476 1.028-5.964 1.687-9.87 1.687-3.904 0-7.393-.66-9.868-1.687-1.24-.515-2.177-1.103-2.79-1.705-.609-.598-.84-1.149-.84-1.63 0-.483.231-1.033.84-1.631.613-.602 1.55-1.19 2.79-1.705 2.475-1.028 5.964-1.687 9.869-1.687ZM12-1.18v26.618M25.305 12.13H-1.313"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coordinate-system_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCoordinateSystem;